module.exports = __webpack_public_path__ + "static/img/11.b22b564.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/eng/11.png
// module id = Wv3d
// module chunks = 0